import { Component, OnInit } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-footer',
  imports: [MatToolbar, RouterLink, FormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true,
})
export class FooterComponent implements OnInit {
  localesList = [
    { code: 'de', label: 'Deutsch' },
    // { code: 'en', label: 'Englisch' },
  ];

  currentLanguage: string | undefined;

  constructor(private router: Router) {}

  ngOnInit(): void {
    const url = this.router.url;

    if (url.includes('/de')) {
      this.currentLanguage = 'de';
    } else if (url.includes('/en')) {
      this.currentLanguage = 'en';
    } else {
      this.currentLanguage = 'de';
    }

    console.log('Current language on init:', this.currentLanguage);
  }

  onLanguageChange(event: Event) {
    const selectedLanguage = (event.target as HTMLSelectElement).value;

    let currentUrl = this.router.url;
    console.log('Current URL before language switch: ', currentUrl);

    if (currentUrl.startsWith('/de')) {
      currentUrl = currentUrl.replace('/de', '');
    } else if (currentUrl.startsWith('/en')) {
      currentUrl = currentUrl.replace('/en', '');
    }

    if (currentUrl === '') {
      currentUrl = '/';
    }

    console.log('Navigating to: /' + selectedLanguage + currentUrl);

    window.location.href = `/${selectedLanguage}${currentUrl}`;
  }
}
